export default __webpack_public_path__ + "static/media/wow-riders.fb411fca.png";